import React, { createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallow } from "zustand/shallow";
import Spinner from "../components/misc/Spinner";
import { useSettingsStore } from "../stores/settings";

export const SettingsContext = createContext();

export const SettingsProvider = (props) => {
  const { i18n } = useTranslation();
  const [env, whitelabel, translation, features, fetchWhitelabeling, fetchTranslation, fetchEnv, fetchFeatures] =
    useSettingsStore(
      (state) => [
        state.env,
        state.whitelabel,
        state.translation,
        state.features,
        state.fetchWhitelabeling,
        state.fetchTranslation,
        state.fetchEnv,
        state.fetchFeatures,
      ],
      shallow,
    );

  useEffect(() => {
    fetchWhitelabeling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchEnv();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (whitelabel === null || !translation === null || env === null) {
    return <Spinner />;
  }

  // Keep the "custom" namespace in sync with DB overrides.
  // deep=true merges nested keys, overwrite=true replaces existing values,
  // and the implicit emit triggers re-renders in useTranslation() consumers.
  if (translation && Object.keys(translation).length > 0) {
    i18n.addResourceBundle("de", "custom", JSON.parse(JSON.stringify(translation)), true, true);
  } else {
    i18n.addResourceBundle("de", "custom", {}, true, true);
  }

  return <SettingsContext.Provider value={{ whitelabel, env, features }}>{props.children}</SettingsContext.Provider>;
};
